import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import Performance from './assets/Performance.png';
import Perf2 from './assets/Perf2.png';
import FIEO from './assets/FIEO.jpg';
import Kt from './assets/Kt.png';
import CGS from './assets/CGS.png';
import apl from './assets/apl.jpg';

const ImagePopup = ({ image, title, onClose }) => (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 bg-black/90 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={onClose}>
        <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.8, opacity: 0 }} className="relative max-w-4xl w-full bg-neutral-100 dark:bg-neutral-900/80 backdrop-blur-lg border border-black/10 dark:border-white/10 rounded-lg shadow-2xl" onClick={e => e.stopPropagation()}>
            <button onClick={onClose} className="absolute -top-4 -right-4 bg-white dark:bg-black text-black dark:text-white rounded-full p-2 hover:bg-gray-200 dark:hover:bg-neutral-800 transition-colors z-10"><svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button>
            <div className="relative"><img src={image} alt={title} className="w-full h-[70vh] object-contain rounded-t-lg" /></div>
            <div className="p-5 bg-neutral-100 dark:bg-neutral-900/80 rounded-b-lg"><h3 className="text-xl font-semibold text-black dark:text-white font-heading">{title}</h3></div>
        </motion.div>
    </motion.div>
);

const Achievements = () => {
    const achievements = [
        { title: "AL-KOOHEJI Performance Certificate", subtitle: "Global Certification", image: Performance },
        { title: "ALMOAYYED Performance Certificate", subtitle: "International Certification", image: Perf2 },
        { title: "FIEO Registered", subtitle: "Federation Of Indian Export Organisations", image: FIEO },
        { title: "Expand India's Exports", subtitle: "Kuwait Times", image: Kt },
        { title: "Indian Diaspora at Kuwait", subtitle: "CGS Info", image: CGS },
        { title: "M/s Zohal Construction Company", subtitle: "Kingdom Of Bahrain", image: apl }
    ];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % achievements.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [achievements.length]);

    const getCardStyle = (index) => {
        const offset = index - currentIndex;
        const total = achievements.length;
        let effectiveOffset = offset;
        if (offset > total / 2) {
            effectiveOffset = offset - total;
        } else if (offset < -total / 2) {
            effectiveOffset = offset + total;
        }

        const x = effectiveOffset * 50;
        const scale = 1 - Math.abs(effectiveOffset) * 0.15;
        const opacity = 1 - Math.abs(effectiveOffset) * 0.3;
        const blur = Math.pow(Math.abs(effectiveOffset), 2) * 2;
        const zIndex = total - Math.abs(effectiveOffset);

        return {
            transform: `translateX(${x}%) scale(${scale})`,
            opacity,
            filter: `blur(${blur}px)`,
            zIndex,
        };
    };

    return (
        <div className="w-full flex flex-col items-center justify-center">
            <AnimatePresence>{selectedImage && <ImagePopup image={selectedImage.image} title={selectedImage.title} onClose={() => setSelectedImage(null)} />}</AnimatePresence>
            <div>
                <div className="text-center mb-8">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black dark:text-white mb-4 font-heading">Our Achievements</h2>
                    <div className="w-24 h-1 bg-black dark:bg-white rounded-full mx-auto"></div>
                </div>
                <div className="relative h-[400px] sm:h-[450px] w-[280px] sm:w-auto max-w-xs sm:max-w-sm md:max-w-md flex items-center justify-center">
                    <AnimatePresence initial={false}>
                        {achievements.map((achievement, index) => (
                            <motion.div
                                key={achievement.title + index}
                                animate={getCardStyle(index)}
                                transition={{ type: "spring", stiffness: 100, damping: 20 }}
                                className="absolute w-full h-[380px] cursor-pointer"
                                onClick={() => index === currentIndex && setSelectedImage(achievement)}
                            >
                                <div className="w-full h-full bg-white/50 dark:bg-white/5 backdrop-blur-md border border-black/10 dark:border-white/10 rounded-2xl overflow-hidden group">
                                    <div className="relative h-2/3 overflow-hidden">
                                        <img src={achievement.image} alt={achievement.title} className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110" />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                                    </div>
                                    <div className="p-6 h-1/3 bg-black/90 dark:bg-black flex flex-col justify-center">
                                        <h3 className="text-xl font-bold text-white mb-2 font-heading">{achievement.title}</h3>
                                        <p className="text-neutral-400">{achievement.subtitle}</p>
                                        </div>
                                </div>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </div>
                <div className="flex justify-center gap-2 mt-4">
                    {achievements.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentIndex(index)}
                            className={`w-2 h-2 rounded-full transition-all duration-300 ${currentIndex === index ? 'w-6 bg-black dark:bg-white' : 'bg-gray-400 dark:bg-neutral-600'}`}
                        />
                    ))}
                </div>
                
            </div>
        </div>
    );
};

export default Achievements;